<template>
  <AppHeaderBack>Reset Password</AppHeaderBack>
  <div class="min-h-screen bg-gray-100 pt-8 pb-8 px-4">
    <div class="max-w-3xl mx-auto">
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
    
        
        <div class="p-6">

          <form class="space-y-5" @submit.prevent="resetPassword">
            <!-- Email Input -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-1 text-left">Email</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-primary focus:border-primary placeholder-gray-400 transition duration-200"
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <!-- Success Message -->
            <div v-if="message" class="p-4 rounded-lg bg-green-50 border border-green-100 text-green-700">
              {{ message }}
            </div>

            <!-- Submit Button -->
            <button
              type="submit"
              class="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition duration-200"
            >
              Send Reset Link
              <span class="material-symbols-outlined ml-2">send</span>
            </button>
          </form>

          <div class="mt-6">
            <div class="relative">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-300"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-2 bg-white/80 text-gray-500">Remember your password?</span>
              </div>
            </div>

            <div class="mt-6">
              <router-link to="/login" class="w-full flex justify-center items-center py-3 px-4 border border-gray-300 rounded-lg shadow-sm text-lg font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition duration-200">
                Back to Login
                <span class="material-symbols-outlined ml-2">arrow_back</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendPasswordReset } from '@/composables/useAuth';
import AppHeaderBack from '@/components/common/AppHeaderBack.vue';

export default {
  components: { AppHeaderBack },
  data() {
    return {
      email: '',
      message: ''
    };
  },
  methods: {
    async resetPassword() {
      if (!this.email) {
        this.$store.dispatch('showAlert', { message: "Please enter your email.", type: "error" });
        return;
      }

      try {
        await sendPasswordReset(this.email);
        this.message = "Password reset email sent! Check your inbox.";
        this.$store.dispatch('showAlert', { message: "Password reset email sent!", type: "success" });
      } catch (error) {
        this.$store.dispatch('showAlert', { message: error.message, type: "error" });
      }
    }
  }
};
</script>